import { format } from "date-fns";
import { isNil } from "lodash";
import moment from "moment-timezone";

export function convertDateToIsoString(start: Date, end?: Date | null): { start: string; end: string } {
    const convertedStart = moment(start).utc().startOf("day");
    if (isNil(end)) {
        end = start;
    }
    const convertedEnd = moment(end).utc().startOf("day").add(1, "day").subtract(1, "second");

    return {
        start: convertedStart.toISOString(),
        end: convertedEnd.toISOString(),
    };
}

let userCountry : string | undefined = undefined;

export function setUserCountry(country: string) { 
    userCountry = country;
}

function getUserTimezone(): string {
    const zones = userCountry ? moment.tz.zonesForCountry(userCountry.toUpperCase()) : [];
    return zones && zones.length > 0 ? zones[0] : "UTC";
}

export function getLocalizedDate(date: DateOrStringOrNumber | null | undefined, endOfDay: boolean = false): string | null {
    if (!date) {
        return null;
    }
    if (typeof date === "string" || typeof date === "number") {
        date = new Date(date);
    }
    const m = moment.tz(format(date, "yyyy-MM-dd"), getUserTimezone());
    if (endOfDay) {
        m.hours(23).minutes(59).seconds(59);
    }
    return m.format();
};

export function getLocalizedCurrentDateTimeIfToday(activationDate: string, now = new Date()): string {
    const timezone = getUserTimezone();
    const localizedActivationDate = moment(activationDate).tz(timezone);
    const localizedNow = moment(now).tz(timezone);

    return localizedActivationDate.isSame(localizedNow, "day")
        ? localizedNow.format()
        : activationDate;
}